export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";